'use strict';

/* eslint-disable no-underscore-dangle */

// Constant Includes
var CONFIG = require('../constants/select');

// Constants
var ATTRIBUTES = {
    DATA: {
        SELECT_PARENT: 'select-parent'
    }
};
var HTML_CLASS = {
    SELECT2: 'select2'
};
var DEFAULT_OPTION = 'default';

/**
 * Creates a customizable select element using select2 library.
 * @constructor
 * @param {JQuery<HTMLElement> | string} $element - select element to use on select2 element build
 * @param {string} id - Object instance identifier. Useful to get object instance after page load.
 * @param {Object} _options - based on https://select2.org/configuration/options-api
 */
function SelectModel($element, id, _options = DEFAULT_OPTION) {
    this.$element = $($element);
    this.id = id;
    this.$select2 = null;
    this.$dropdownParent = $(this.$element.data(ATTRIBUTES.DATA.SELECT_PARENT));

    var options = CONFIG.OPTIONS[_options];

    if (options === undefined || options === null) {
        options = CONFIG.OPTIONS[DEFAULT_OPTION];
    }

    this.options = options;

    if (this.$dropdownParent.length) {
        this.options.dropdownParent = this.$dropdownParent;
    } else if (this.$element.parent().length) {
        this.options.dropdownParent = this.$element.parent();
    }
}

/**
 * Initialize select 2 based on $element (jquery element).
 */
SelectModel.prototype.initSelect2 = function () {
    if (this.$element.length) {
        $(this.$element).select2(this.options);
    }

    this.$select2 = this.$element.siblings(`.${HTML_CLASS.SELECT2}`);
};

/**
 * Remove select 2 from current page.
 */
SelectModel.prototype.destroySelect2 = function () {
    this.$element.select2('destroy');
};

module.exports = SelectModel;
